
const {ccclass, property} = cc._decorator;
/**
 * 机器人回复
 */
@ccclass
export default class RobotItemNode extends cc.Component {

    @property(cc.Label)
    lbContent: cc.Label = null;

    onLoad () {

    }

    start () {

    }

    /**
     * 绑定数据
     */
    bindData( desc : string ){
        let actualDesc = "";
        do{
            if ( !desc ){
                break;
            }
            if ( desc.length <= 11 ){
                if ( actualDesc == "" ){
                    actualDesc += desc;
                }else{
                    actualDesc += "\n" + desc;
                }
                desc = "";
            }else{
                if ( actualDesc == "" ){
                    actualDesc += desc.substr( 0 , 10 );
                }else{
                    actualDesc += "\n" + desc.substr( 0 , 10 );
                }
                desc = desc.substr( 10 , desc.length - 1 );
            }
        }while ( desc.length > 0 )
        this.lbContent.string = `${actualDesc}`;
    }




}
